import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { PROXY_PATH } from '../../constants/urls';

import { createZgApiHttpClient } from '../../clients/zgApiHttpClient';

const isDevelopment = process.env.NODE_ENV === 'development';
const localApiUrl = `/${PROXY_PATH}`;
const authApiUrl = isDevelopment ? localApiUrl : process.env.NEXT_PUBLIC_ZG_API_PUBLIC;
const client = createZgApiHttpClient(authApiUrl ?? '').extend({
  timeout: 10_000,
  credentials: isDevelopment ? 'include' : undefined,
});

export const Auth = defineAuthProvider({
  queryOptions: () =>
    RentalManagerUserInfoV2WebApiHandler_get_queryOptions(
      {
        includeCanClaimFreeListings: true,
        includeCustomers: true,
        includeProfileImageUrl: true,
      },
      { httpClient: client },
    ),
  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
